import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { Building2 } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { Reveal, SectionTag } from "./Reveal";
import { fetchPartners, toAbsolute } from "@/lib/api";

const PLACEHOLDERS = ["Ministry", "SmartCity", "HotelGroup", "LogiTrans", "PetroEnergy", "MediCare", "EduTech", "SecureNet"];

export default function Partners() {
  const { t } = useLang();
  const [items, setItems] = useState([]);

  useEffect(() => {
    fetchPartners().then((r) => setItems(r.data || [])).catch(() => setItems([]));
  }, []);

  const hasReal = items.length > 0;
  const list = hasReal ? items : PLACEHOLDERS.map((name, i) => ({ id: `ph-${i}`, name, logo: "", website: "" }));

  return (
    <section className="relative section-pad overflow-hidden" data-testid="partners-section">
      <div className="mx-auto max-w-3xl px-5 sm:px-8 text-center mb-12">
        <Reveal><SectionTag>{t.partners.tag}</SectionTag></Reveal>
        <Reveal delay={0.05}>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold mt-5 mb-4">{t.partners.title}</h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="text-slate-400 leading-relaxed">{t.partners.body}</p>
        </Reveal>
      </div>

      <Marquee speed={35} gradient gradientColor="#050914" gradientWidth={120} pauseOnHover autoFill>
        {list.map((p, i) => {
          const inner = p.logo ? (
            <img src={toAbsolute(p.logo)} alt={p.name} loading="lazy" className="h-12 w-auto max-w-[160px] object-contain" />
          ) : (
            <>
              <Building2 size={26} className="text-primary" />
              <span className="text-xl font-bold whitespace-nowrap">{p.name}</span>
            </>
          );
          const cls = "mx-4 flex items-center gap-3 rounded-2xl border border-white/10 bg-surface px-8 py-5 grayscale hover:grayscale-0 opacity-60 hover:opacity-100 transition-all duration-300 min-h-[80px]";
          return p.website ? (
            <a key={p.id || i} href={p.website} target="_blank" rel="noopener noreferrer" className={cls} data-testid={`partner-${i}`}>{inner}</a>
          ) : (
            <div key={p.id || i} className={cls} data-testid={`partner-${i}`}>{inner}</div>
          );
        })}
      </Marquee>
    </section>
  );
}
